export default __webpack_public_path__ + "static/media/22.244df818.jpg";